import React from "react"
import autobind from "class-autobind"
import { Paper, Toggle } from "material-ui"
import strings from "../../localization/strings"
import PayrollTimeByHierarchy from "./payroll_time/PayrollTimeByHierarchy"
import PayrollTimeByJob from "./payroll_time/PayrollTimeByJob"
import PayrollExpensesByHierarchy from "./payroll_expenses/PayrollExpensesByHierarchy"
import AccountStore from "../../stores/AccountStore"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import { IPayrollTime, IPayrollTimeHierarchy, IPayrollTimeHierarchyEmployee, IPayrollExpenses, IPayrollExpensesHierarchy, IPayrollExpensesHierarchyEmployee } from "../../models"
import _ from "lodash"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
import PayrollExpensesPriorPeriodByHierarchy from "./payroll_expenses/PayrollExpensesPriorPeriodByHierarchy"

interface IProps {
	viewPayrollByJob: boolean

	//props for time
	payrollTimeData: IPayrollTime
	loadingTime: boolean
	selectedPayrollTimeHierarchies: IPayrollTimeHierarchy[]
	selectedPayrollTimeEmployees: IPayrollTimeHierarchyEmployee[]	
	onTimeDownload(): void
	onTimeReportDownload(): void
	onTimeLock(): void
	onTimeUnLock(): void
	onTimeEmployeeLock(): void
	onTimeEmployeeUnLock(): void
	onTimeClose(): void
	onTimeExport(): void
	showTimecardPopup(employeeId: string, referenceDate: string): void
	handleSelectPayrollTimeHierarchy(selectedPayrollHierarchies: IPayrollTimeHierarchy[]): void
	handleSelectPayrollTimeEmployee(selectedEmployees: IPayrollTimeHierarchyEmployee[], unselectedEmployees: IPayrollTimeHierarchyEmployee[]): void
	handleInitSelectedPayrollTimeEmployees(): void

	//props for expenses
	payrollExpensesData: IPayrollExpenses
	payrollPriorPeriodExpensesData: IPayrollExpenses
	loadingExpenses: boolean
	selectedPayrollExpenseHierarchies: IPayrollExpensesHierarchy[]
	selectedPayrollExpenseEmployees: IPayrollExpensesHierarchyEmployee[]
	onExpensesDownload(): void
	onExpensesReportDownload(): void
	onExpensesLock(): void
	onExpensesUnLock(): void
	onExpensesEmployeeLock(): void
	onExpensesEmployeeUnLock(): void
	onExpensesClose(): void
	onExpensesExport(): void
	onPriorPeriodExpensesDownload(): void
	onPriorPeriodExpensesExport(): void
	handleSelectPayrollExpensesHierarchy(selectedHierarchies: IPayrollExpensesHierarchy[]): void
	handleSelectPayrollExpensesEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]): void
	handleInitSelectedPayrollExpensesEmployees(): void
	handleSelectPayrollPriorPeriodExpensesHierarchy(selectedHierarchies: IPayrollExpensesHierarchy[]): void
	handleSelectPayrollPriorPeriodExpensesEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]): void
	onExpensePayrollFileDownload(expenseId: string): void
	reloadTimeCard: () => void
}
interface IState {
	failedExportsOnly: boolean
	showContent: boolean
}

export default class PayrollByHierarchyCard extends React.Component<IProps, IState> {
	private PayrollTimeByHierarchy = null
	private PayrollExpensesByHierarchy = null
	private PayrollExpensesPriorPeriodByHierarchy = null
	constructor(props: IProps) {
		super(props)
		this.state = {
			failedExportsOnly: false,
			showContent: true
		}
		autobind(this)
	}

	render() {
		const payrollTimeData = _.cloneDeep(this.props.payrollTimeData)
		const payrollExpensesData = _.cloneDeep(this.props.payrollExpensesData)
		const payrollPriorPeriodExpensesData = _.cloneDeep(this.props.payrollPriorPeriodExpensesData)

		if (this.state.failedExportsOnly) {
			if (payrollTimeData && payrollTimeData.PayrollTimeHierarchies) {
				payrollTimeData.PayrollTimeHierarchies = payrollTimeData.PayrollTimeHierarchies.filter(hierarchy => {
					hierarchy.PayrollEmployees = hierarchy.PayrollEmployees.filter(i => i.Exported === false && i.ExportedBy)
					return hierarchy.PayrollEmployees.length > 0
				})
			}
			if (payrollExpensesData && payrollExpensesData.PayrollExpensesHierarchies) {
				payrollExpensesData.PayrollExpensesHierarchies = payrollExpensesData.PayrollExpensesHierarchies.filter(hierarchy => {
					hierarchy.Employees = hierarchy.Employees.filter(i => i.Exported === false && i.ExportedBy)
					return hierarchy.Employees.length > 0
				})
			}
		}
		return (
			<Paper zDepth={1} className="page-paper" style={{ marginTop: 25, padding: "25px 20px", position: "relative" }}>

				{this.state.showContent && (
					this.props.viewPayrollByJob ?
						<div>
							<div style={{ fontSize: 18, fontWeight: 600, paddingLeft: 15, marginTop: -5, marginBottom: 10 }}>{checkJobFieldAvailable('singular') ? `Payroll by ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Payroll_by_Job}</div>
							<PayrollTimeByJob
								loading={this.props.loadingTime}
								payrollData={this.props.payrollTimeData}
								showTimecardPopup={this.props.showTimecardPopup}
								reloadTimeCard={this.props.reloadTimeCard}
							/>
						</div> :
						<div>
							<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>

								<div style={{ fontSize: 18, fontWeight: 600, paddingLeft: 15, marginTop: -5, marginBottom: 10 }}>{strings.Payroll_by_Hierarchy}</div>
								{!this.props.viewPayrollByJob &&
									<Toggle
										label={strings.Failed_Exports_Only}
										toggled={this.state.failedExportsOnly}
										style={{ width: 175, }}
										onToggle={(e, failedExportsOnly) => {
											this.props.handleSelectPayrollTimeHierarchy([])
											this.props.handleSelectPayrollExpensesHierarchy([])
											this.props.handleInitSelectedPayrollTimeEmployees()
											this.props.handleInitSelectedPayrollExpensesEmployees()
											this.setState({ failedExportsOnly, showContent: false }, () => this.setState({ showContent: true }))
										}}
									/>
								}
							</div>
							{permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
								<PayrollTimeByHierarchy
									ref={(elem) => this.PayrollTimeByHierarchy = elem}
									payrollData={payrollTimeData}
									loading={this.props.loadingTime}
									selectedPayrollHierarchies={this.props.selectedPayrollTimeHierarchies}
									selectedEmployees={this.props.selectedPayrollTimeEmployees}
									onDownload={this.props.onTimeDownload}
									onDownloadTimeReport={this.props.onTimeReportDownload}
									onLock={this.props.onTimeLock}
									onUnLock={this.props.onTimeUnLock}
									onEmployeeLock={this.props.onTimeEmployeeLock}
									onEmployeeUnLock={this.props.onTimeEmployeeUnLock}
									onClose={this.props.onTimeClose}
									onExport={this.props.onTimeExport}
									showTimecardPopup={this.props.showTimecardPopup}
									handleSelectPayrollHierarchy={this.props.handleSelectPayrollTimeHierarchy}
									handleSelectEmployee={this.props.handleSelectPayrollTimeEmployee}
									reloadTimeCard={this.props.reloadTimeCard}
								/>
							}
							{AccountStore.getExpensesEnabled() &&
								!AccountStore.getExpenseIsPayrollTime() &&
								permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense) &&
								<PayrollExpensesByHierarchy
									ref={(elem) => this.PayrollExpensesByHierarchy = elem}
									payrollExpensesData={payrollExpensesData}
									loading={this.props.loadingExpenses}
									selectedHierarchies={this.props.selectedPayrollExpenseHierarchies}
									selectedEmployees={this.props.selectedPayrollExpenseEmployees}
									onDownload={this.props.onExpensesDownload}
									onDownloadExpensesReport={this.props.onExpensesReportDownload}
									onLock={this.props.onExpensesLock}
									onUnLock={this.props.onExpensesUnLock}
									onEmployeeLock={this.props.onExpensesEmployeeLock}
									onEmployeeUnLock={this.props.onExpensesEmployeeUnLock}
									onClose={this.props.onExpensesClose}
									onExport={this.props.onExpensesExport}
									handleSelectHierarchy={this.props.handleSelectPayrollExpensesHierarchy}
									handleSelectEmployee={this.props.handleSelectPayrollExpensesEmployee}
								/>
							}
							{AccountStore.getPriorPeriodAdjustmentsEnabled() &&
								AccountStore.getExpensesEnabled() &&
								!AccountStore.getExpenseIsPayrollTime() &&
								permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense) &&
								<PayrollExpensesPriorPeriodByHierarchy
									ref={(elem) => this.PayrollExpensesPriorPeriodByHierarchy = elem}
									payrollExpensesData={payrollPriorPeriodExpensesData}
									loading={this.props.loadingExpenses}
									selectedHierarchies={this.props.selectedPayrollExpenseHierarchies}
									onDownload={this.props.onPriorPeriodExpensesDownload}
									onLock={this.props.onExpensesLock}
									onUnLock={this.props.onExpensesUnLock}
									onEmployeeLock={this.props.onExpensesEmployeeLock}
									onEmployeeUnLock={this.props.onExpensesEmployeeUnLock}
									onClose={this.props.onExpensesClose}
									onExport={this.props.onPriorPeriodExpensesExport}
									handleSelectHierarchy={this.props.handleSelectPayrollPriorPeriodExpensesHierarchy}
									handleSelectEmployee={this.props.handleSelectPayrollPriorPeriodExpensesEmployee}
									onExpensePayrollFileDownload={this.props.onExpensePayrollFileDownload}
								/>
							}
						</div>
				)}
			</Paper>
		)
	}
}
